import { Stack } from "@chakra-ui/layout";
import { Skeleton } from "@chakra-ui/skeleton";

const ChatLoading = () => {
  return (
    <Stack spacing={2}>
      {Array.from({ length: 10 }).map((_, i) => (
        <Skeleton
          key={i}
          height="58px"
          borderRadius="14px"
          startColor="#EAD9AC"
          endColor="#F7EBCB"
        />
      ))}
    </Stack>
  );
};

export default ChatLoading;
